import { start as startWallDetection } from "./detection.js";
import { start as startHavenExperiment } from "./haven.js";
export function start() {
    void startHavenExperiment();
    startWallDetection();
}
start();
